import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	InstallationPhotoFiles,
	ExitButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderDatesPanel,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	SubmitPhotosButton,
	CreateEstimateButton,
	RetailOrderCommunicationButton
} from '../../../features/cfi/retail-order';
import { FileTypes } from '../../../types/enums';
import '../../../css/order.scss';

export default function UploadPhotosPage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards showPaymentInformationCard={true} />

			<RetailOrderProgress />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SubmitPhotosButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton defaultFileType={FileTypes.DisplayPhoto} />
						</ToolbarItem>
						<ToolbarItem>
							<CreateEstimateButton />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>

			<Box>
				<Item ratio={1}>
					<RetailOrderDatesPanel
						showScheduledInstallDates={false}
						showInvoiceDate={false}
						editCabinetDates={false} />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<InstallationPhotoFiles />

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
